import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditsItem, PaymentsMethod } from '../types/bank'

const bonusList = [
  { id: 0, name: 'Bônus de Esportes', balance: 0.0 },
  { id: 1, name: 'Bônus de Casino', balance: 0.0 },
  { id: 2, name: 'Bônus de Jogos', balance: 0.0 },
  { id: 3, name: 'Bônus de Poker', balance: 0.0 },
]

export const initialBalance: CreditsItem = {
  id: 0,
  name: '',
  balance: 0.0,
}

export const initialState = {
  items: [] as CreditsItem[],
  bonus: bonusList as CreditsItem[],
  totalBalance: 0,
  paymentMethods: [] as PaymentsMethod[],
}

export const creditsReducer = createSlice({
  name: 'credits',
  initialState,
  reducers: {
    setSports: (state, action: PayloadAction<{ items: CreditsItem[] }>) => {
      state.items = action.payload.items
    },
    setPaymentMethods: (
      state,
      action: PayloadAction<{ paymentMethods: PaymentsMethod[] }>,
    ) => {
      state.paymentMethods = action.payload.paymentMethods
    },
  },
})

export const { setSports, setPaymentMethods } = creditsReducer.actions

export default creditsReducer.reducer
